import { toast } from "$global-providers/toast-provider";
import type { PriceList } from "$routes/patient/[:patientId]/_lib/invoices/components/InvoiceCard/types";
import { defineMessage, useIntl } from "react-intl";
import LegacyLaserReceiptPrint from "../invoices/components/InvoiceCard/InvoiceDetails/Receipt/LaserReceiptPrint";
import { useFetchPrintableInvoiceRxdb } from "./use-fetch-printable-invoice-rxdb";

const ERROR_MESSAGE = defineMessage({
  id: "invoicing.getInvoice.error.msg",
  defaultMessage: "Failed to fetch this invoice",
});

type PrintableLaserReceiptV2Props = {
  syncInvoiceId: string;
  priceList: PriceList | null;
  onAfterPrint: () => void;
};

export const PrintableLaserReceiptV2 = ({
  syncInvoiceId,
  priceList,
  onAfterPrint,
}: PrintableLaserReceiptV2Props) => {
  const { formatMessage } = useIntl();
  const { invoice, loading } = useFetchPrintableInvoiceRxdb(
    syncInvoiceId,
    priceList,
  );

  if (loading) {
    return null;
  }

  if (!invoice) {
    toast.error(formatMessage(ERROR_MESSAGE));
    onAfterPrint();
    return null;
  }

  return (
    <LegacyLaserReceiptPrint
      onAfterPrint={onAfterPrint}
      invoice={invoice}
      printReceiptOnly
      invoicesToPrint={[]}
    />
  );
};
